import axios from 'axios';
import Cookies from 'js-cookie';
// import { format } from '../js/i18n';
import { Toast } from 'antd-mobile';
import {
  systemErrCode,
  timeoutErrCode,
  cancelErrCode,
  networkErrCode
} from '@/asset/config/constant';
// import AppCore from 'appcore';
import { getValueFromUA } from './utils';
// 优化后的URL匹配正则，支持http/https协议和相对路径
const urlTest = /^(https?:)?\/\/([^/]+)/;
const appToken = getValueFromUA('appPlatform');
const CancelToken = axios.CancelToken;
axios.defaults.headers.common['platform'] = 'wap';
axios.defaults.headers.common['appPlatform'] = !appToken ? 3 : appToken === 'android' ? 1 : 2;
axios.defaults.headers.common['Authorization'] =
  process.env.NODE_ENV === 'development'
    ? 'xV9GddHD4Wt2DXwjOehusOeBzPjPvB8PbKdEE+j+H0iubPJxtGs5dDP4Ze178yW5'
    : getValueFromUA('Authorization') || Cookies.get('Authorization'); //  AppCore.getToken(getOsType()) 安卓是回调函数方式设置的，异步获取token会设置不成功
// axios.defaults.headers.common['Authorization'] = process.env.NODE_ENV === 'development' ? '57g90vj3ajSxGTdUrYcIMxiNcvA4uezxIffSZQrtjKmubPJxtGs5dDP4Ze178yW5' : getValueFromUA('Authorization') || Cookies.get('Authorization'); //  AppCore.getToken(getOsType()) 安卓是回调函数方式设置的，异步获取token会设置不成功
axios.defaults.headers.common['deviceid'] = process.env.NODE_ENV === 'development' ? '14380891-A2EC-48EB-9A92-B387ADA1CB23' : getValueFromUA('deviceId');
axios.defaults.headers.common['appVersionName'] = getValueFromUA('version') || '';
axios.defaults.headers.common['brand'] = getValueFromUA('manufacturer') || '';
axios.defaults.headers.common['model'] = getValueFromUA('model') || '';
axios.defaults.headers.common['appVersionCode'] = getValueFromUA('versionInt') || '';
axios.defaults.headers.common['apiLevel'] = getValueFromUA('apiLevel') || '13';
axios.defaults.headers.common['iosApiLevel'] = getValueFromUA('iosApiLevel') || '13';
axios.defaults.headers.common['gender'] =
  process.env.NODE_ENV === 'development' ? 0 : getValueFromUA('gender') || '-1'; // 开发环境写为0，可修改，测试线上取ua数据
axios.defaults.headers.common['packageName'] = getValueFromUA('pkg') || '';
axios.defaults.headers.common['country'] = getValueFromUA('country') || '';
axios.defaults.headers.common['user_id'] = process.env.NODE_ENV === 'development' ? '1910217319097913345' : getValueFromUA('userid') || '';

axios.defaults.timeout = 30000;
window.axios = axios;

const lockUrl = {};
window.lockUrl = {};
// 后到优先策略：取消前一个未完成的ajax请求，然后发送新的ajax请求
const s1 = /^@.+/;

// 节约型策略：即共享类型，由同类型的第一个请求发送ajax，（在第一个ajax返回之前的）后续的同类型共享ajax返回结果
const s2 = /^\\!.+/;

const detailLockKey = (config, promise) => {
  const { lockKey } = config;
  if (!lockKey) {
    return promise;
  }

  try {
    lockUrl[lockKey] = lockUrl[lockKey] || [];
    const cur = lockUrl[lockKey].slice(0);

    // 取消前面的请求
    if (cur.length && s1.test(lockKey)) {
      cur.forEach(one => {
        try {
          if (one.config.source && typeof one.config.source.cancel === 'function') {
            one.config.source.cancel('新请求覆盖旧请求');
          }
        } catch (cancelError) {
          console.warn('取消请求失败:', cancelError);
        }
      });
      lockUrl[lockKey] = [];
    }

    // 添加错误处理
    promise.catch(error => {
      // 清理锁状态
      if (lockUrl[lockKey]) {
        const index = lockUrl[lockKey].findIndex(item => item.promise === promise);
        if (index > -1) {
          lockUrl[lockKey].splice(index, 1);
        }
      }
    });

    lockUrl[lockKey].push({
      promise,
      config
    });

    return promise;
  } catch (error) {
    console.error('请求锁处理错误:', error);
    return promise; // 出错时返回原始promise
  }
};

let lastDate = {};

// 添加时间戳
axios.interceptors.request.use(
  function (config) {
    // 先从window上取默认值，如果取到就用window上的
    const globalConfig = window.config || {};
    const country = globalConfig.country;
    const lang = globalConfig.lang;
    const params = config.params || {};
    const transformRequest = config.transformRequest || [];
    transformRequest.push(function (data, headers) {
      const hasJSONContentType = () => {
        const contentType = (headers && headers['Content-Type']) || '';
        // 判断是否是加密请求
        const hasxAuthKey = (headers && headers['x-auth-key']) || '';
        return contentType.indexOf('application/json') > -1 && hasxAuthKey;
      };
      if (typeof data === 'string' && hasJSONContentType()) {
        console.log(data, 'transformRequest');
        // 使用正则表达式截取双引号中间的内容
        const match = data.match(/"([^"]*)"/);
        return match ? match[1] : data;
      }
      return data;
    });
    let headers = config.headers || {};
    // 先写死1，后期添加国家会有多种
    headers['country'] = country || '';
    headers['lang'] = lang;
    headers['language'] = lang;
    // lastDate[config.url] = +new Date();
    // params._t = lastDate[config.url] + parseInt(localStorage.getItem('serverTimeDiff') || '0');
    params._t = +new Date();
    // 优化后的跨域检测逻辑
    const urlMatch = config.url.match(urlTest);
    if (urlMatch) {
      // 提取主机名（不包含端口号）
      const requestHost = urlMatch[2] ? urlMatch[2].split(':')[0] : null;
      const currentHost = window.location.hostname;

      // 发出的请求是跨站的，则去掉所有header
      if (requestHost && requestHost !== currentHost) {
        console.log(`跨域请求检测: ${requestHost} !== ${currentHost}`);
        headers = {};
      }
    }
    config.params = params;
    config.headers = headers;
    config.transformRequest = transformRequest;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (res) {
    const systemErrInfo = 'ajax.system';
    const data = res.data;
    const status = res.status;
    const headers = res.headers;
    const { url } = res.config;
    // 加密之后的数据
    if (res.headers['x-auth-key']) {
      return {
        code: !!res.data ? 1 : 0,
        body: res.data,
        headers: res.headers
      }
    }
    // 将statusCode放上
    if (typeof data === 'object') {
      data.statusCode = status;
    }
    if ((status >= 200 && status < 300) || status === 401) {
      if (!data || (typeof data === 'string' && data.indexOf('<!DOCTYPE') >= 0)) {
        return {
          code: systemErrCode,
          message: systemErrInfo,
          headers: headers
        };
      }
      // 返回数据没有bizCode字段认为出错了
      if (typeof data === 'object' && !data.code && !data.bizCode && !data.result) {
        return {
          code: systemErrCode,
          message: systemErrInfo,
          headers: headers
        };
      }
      if (data.code !== 10000 && data.code !== 1 && data.message) {
        // console.log(headers, 'headers');
        // // 处理非 2xx 状态码的响应头中的 date 字段
        // if ((headers['date'] || headers['Date'])) {
        //   try {
        //     const dateHeader = headers['date'] || headers['Date'];
        //     const serverTimestamp = new Date(dateHeader).getTime();
        //     console.log(serverTimestamp, 'serverTimestamp');
            
        //     if (!isNaN(serverTimestamp) && lastDate[url]) {
        //       // 计算时间差（毫秒）
        //       const timeDiff = serverTimestamp - lastDate[url];
        //       console.log('服务器时间差:', timeDiff, 'ms');
              
        //       // 存储到 localStorage
        //       localStorage.setItem('serverTimeDiff', timeDiff.toString());
        //     }
        //   } catch (error) {
        //     console.error('处理 date 响应头失败:', error);
        //   }
        // }
        Toast.show({
          content: data.message
        });
      }
      // 保留 headers 信息
      return {
        ...data,
        headers: headers
      };
    }
    return {
      code: systemErrCode,
      message: systemErrInfo,
      headers: headers
    };
  },
  function (err) {
    const timeoutErrInfo = 'ajax.timeout';
    const systemErrInfo = 'ajax.system';
    const networkErrInfo = 'ajax.network';
    
    // 处理响应头中的 date 字段
    const handleDateHeader = (headers) => {
      if (headers && (headers['date'] || headers['Date'])) {
        try {
          const dateHeader = headers['date'] || headers['Date'];
          const serverTimestamp = new Date(dateHeader).getTime();
          
          if (!isNaN(serverTimestamp) && lastDate) {
            // 计算时间差（毫秒）
            const timeDiff = serverTimestamp - lastDate;
            console.log('服务器时间差:', timeDiff, 'ms');
            
            // 存储到 localStorage
            localStorage.setItem('serverTimeDiff', timeDiff.toString());
            localStorage.setItem('serverTimeDiffUpdatedAt', Date.now().toString());
          }
        } catch (error) {
          console.error('处理 date 响应头失败:', error);
        }
      }
    };
    
    // 在响应拦截器中改进取消请求的处理
    if (axios.isCancel(err)) {
      console.log('请求被取消:', err.message);
      // 确保返回一个可处理的响应格式
      return {
        code: cancelErrCode,
        message: '请求已取消',
        headers: {},
        cancelled: true // 添加标识
      };
    }
    
    // 从错误对象中获取响应头
    const headers = err.response?.headers || {};
    handleDateHeader(headers);
    
    // console.dir(err);
    const message = err.message;
    // 超时错误
    // message是axios写的
    if (message.startsWith('timeout of')) {
      return {
        code: timeoutErrCode,
        message: timeoutErrInfo,
        headers: headers
      };
    }
    // 没有响应网络错误
    if (message.startsWith('Network Error')) {
      return {
        code: networkErrCode,
        message: networkErrInfo,
        headers: headers
      };
    }
    // 请求被打断
    if (message.startsWith('Request aborted')) {
      return {
        code: systemErrCode,
        message: systemErrInfo,
        headers: headers
      };
    }
    // 系统错误
    return {
      code: systemErrCode,
      message: systemErrInfo,
      headers: headers
    };
  }
);

const req = axios.Axios.prototype.request;
/**
 * 覆盖全局request的方法，方便处理异常出现的情况
 */
axios.Axios.prototype.request = function (config) {
  if (config.lockKey) {
    const source = CancelToken.source();
    config.source = source;
    config.cancelToken = source.token;
  }
  const promise = req.call(this, config);
  return detailLockKey(config, promise);
};
